<h3>Credenciamento PFAC</h3>

<div fxLayout="row" fxLayoutAlign="left stretch">
  <div fxLayoutGap="20px" class="filter-container" *ngIf="hasWriteAccess">
    <div fxFlex="10" fxFlexAlign="center">
      <button class="fd-button" (click)="addPFAC()">
        <div class="d-flex  justify-content-center">
          <fa-icon icon='plus-circle' size="1x"></fa-icon> Incluir CNPJ
        </div>
      </button>
    </div>
  </div>
</div>

<form [formGroup]="formGroup"> 
</form>

<div class='list'>
  <app-list-pfac
  [dataSource]="dataSource" 
  [totalItens]="totalItens" 
  (changePage)="changePage($event)"
  (searchEvent)="getAllGroups(true)" 
  [page]="pageNumberFilter"
  >
  </app-list-pfac>
</div>